import { observer } from 'mobx-react-lite';

import { cn } from '@workspace/ui/lib/utils';

import { ProductCardCompact } from '~/components/ProductCardCompact';
import { ProductListAnalyticsProvider } from '~/components/ProductListAnalytics';
import { useCategoryBlockProductList } from '~/components/ProductListAnalytics/useCategoryBlockProductList';
import type { Category } from '~/stores/CategoriesStore';

import {
  COMPACT_PRODUCT_GRID_CLASS,
  COMPACT_SECTION_TITLE_CLASS,
} from './constants';

interface Props {
  category: Category;
}

/**
 * Product feed of a compact home block: every product of the CMS block in a seven-column grid on desktop, two columns on mobile.
 */
const CompactProductsGridView = ({ category }: Props) => {
  const list = useCategoryBlockProductList(category, 'grid');
  const products = category.products;

  if (products.length === 0) {
    return null;
  }

  return (
    <ProductListAnalyticsProvider list={list}>
      <section className="mt-9">
        <h2 className={cn(COMPACT_SECTION_TITLE_CLASS, 'mb-3!')}>
          {category.name}
        </h2>
        <div className={COMPACT_PRODUCT_GRID_CLASS}>
          {products.map((product, index) => (
            <ProductCardCompact
              key={product.id}
              product={product}
              index={index}
            />
          ))}
        </div>
      </section>
    </ProductListAnalyticsProvider>
  );
};

export const CompactProductsGrid = observer(CompactProductsGridView);
